/**
 * Цвета для графиков активности
 */

/** Цвета для графика */
export const ACTIVITY_CHART_COLORS = {
  normal: "#0059FF",      // blue-500
  exceeded: "#D15B46",    // red-500
  burst: "#f59e0b",       // amber-500 - для всплесков
  grid: "#e5e7eb",        // gray-200
  axis: "#9ca3af",        // gray-400
} as const;
